import { createExtendedState } from 'react-extended-state'

import type { RouterProps, RouterState } from './Domain'

const RouterPropsState = createExtendedState<RouterProps>()
export const ConnectwareRoutingPropsProvider = RouterPropsState.Provider
export const useConnectwareRoutingProps = (): RouterProps => RouterPropsState.useExtendedState((s) => s)

const RouterStateState = createExtendedState<RouterState>()
export const ConnectwareRoutingProvider = RouterStateState.Provider
export const useConnectwareRoutingDispatcher = RouterStateState.useExtendedStateDispatcher
export const useConnectwareRouting = (): RouterState => RouterStateState.useExtendedState((s) => s)
